import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiRP.post("/api/rp-channel-planning-review", params);
};

const getCustomers = params => {
  return restApiRP.post("/api/rp-channel-planning-review/customer", params);
};

const rpChannelPlanningReviewService = {
  getAll,
  getCustomers
};

export default rpChannelPlanningReviewService;